var AnnotationModule = (function (AnnotationModule) {
  var lastTimeStamp = 0;
  var modelCreatedChannel = null;
  var modelElements = {};
  var idMap = {};
  var typeMap = {};
  var marker = Utils.uniqueString();
  var setTypeForModel = function (model, typeId, ui, ctrl, ctrlRo) {
    model.type = typeId;
    typeMap[typeId] = model;
    model.ui = ui;
    model.ctrl = ctrl;
    model.ctrlRo = ctrlRo;
  };
  var animating = false;
  var setAnimating = function (boolVal) {
    console.log("Animating: " + boolVal);
    animating = boolVal;
  };
  var getAnimating = function () {
    return animating;
  };

  var zopimSay = function (msg) {
    try {
      $zopim.livechat.say(msg);
    } catch (e) {}
  };

  var getUIFromId = function (id) {
    return modelElements[idMap[id]].viewObj;
  };

  var checkModel = function (model, data) {
    if (data["annotation_type"] != model.type)
      throw new ParseException(
        model,
        data["annotation_type"],
        "Annotation type mismatch"
      );
  };
  var ignoreCounter = 0;
  var resetIgnoreCounter = function () {
    ignoreCounter = 2;
  };
  var markAsRead = 0;
  var setMarkAsRead = function () {
    markAsRead = 1;
  };

  //Models

  var ParseException = function (model, type, message) {
    this.model = model;
    this.type = type;
    this.message = message;
  };

  var canSetPending = false;

  var enablePending = function () {
    canSetPending = true;
  };

  var MVCModel = function (type) {
    //This is used to support complex rendering
    //of model.
    //in case of simple change (like changing text) we go
    //	controller -> modify model
    //	controller -> modify view
    //when updating a list (complex) we do the following
    //	controller -> modify model -> nodtify view -> re-render view
    var obj = {};
    var id = null;
    var isReadOnly = false;
    var author = "";
    var otherAuthor = false;
    obj.setOtherAuthor = function (oA) {
      if (oA) isReadOnly = true;
      otherAuthor = oA;
    };
    obj.isOtherAuthor = function () {
      return otherAuthor;
    };
    obj.getType = function () {
      return type;
    };
    obj.setAuthor = function (newAuthor) {
      author = newAuthor;
      obj.notify({ author: newAuthor });
    };
    obj.getAuthor = function () {
      return author;
    };
    obj.channel = Utils.uniqueString();
    obj.readOnly = function () {
      return isReadOnly;
    };
    obj.setReadOnly = function (ro) {
      isReadOnly = ro;
    };
    obj.setId = function (newId) {
      obj.notify({ id: newId });
      id = newId;
      idMap[id] = obj.channel;
    };
    obj.getId = function () {
      return id;
    };
    obj.notify = function (data) {
      $.Topic(obj.channel).publish(data);
    };
    modelElements[obj.channel] = obj;
    obj._cleanup = function () {
      $.Topic(obj.channel).publish({ deleted: true });
      delete modelElements[obj.channel];
    };
    obj.cleanup = function () {
      obj._cleanup();
    };
    obj._serialize = function () {
      var data = { annotation_type: type.type, channel: obj.channel };
      if (id) data.id = id;
      return data;
    };
    obj.notifyCreated = function () {
      $.Topic(modelCreatedChannel).publish(type, obj);
    };
    return obj;
  };

  MVCModel._new = function (model, data) {
    if (data.id && idMap[data.id]) data.channel = idMap[data.id];
    if (data["channel"]) {
      var newModel = modelElements[data["channel"]];
    } else {
      var newModel = model();
    }
    newModel.setId(data["id"]);
    newModel.setOtherAuthor(data["read_only"]);
    newModel.setAuthor(data["author_name"]);
    return newModel;
  };

  var CutAxis = function () {
    var obj = MVCModel(CutAxis);
    var x = 0;
    var y = 0;
    var z = 0;
    var w = 0;
    obj.serialize = function () {
      var data = { x: x, y: y, z: z, w: w };
      $.extend(data, obj._serialize());
      return data;
    };
    obj.setCutData = function (_x, _y, _z, _w) {
      x = _x;
      y = _y;
      z = _z;
      w = _w;
    };
    obj.cutViewer = function (viewer) {
      viewer.setCutAxis(x, y, z, w);
    };
    return obj;
  };

  CutAxis.parse = function (data, elements) {
    checkModel(CutAxis, data);
    var cutAxis = MVCModel._new(CutAxis, data);
    cutAxis.setCutData(data["x"], data["y"], data["z"], data["w"]);
    if (elements) elements.push(cutAxis);
    if (!data["channel"]) cutAxis.notifyCreated();
    return cutAxis;
  };

  var MVCModelViewElem = function (type) {
    var obj = MVCModel(type);
    var view = null;
    var _serialize = function () {
      if (view) var id = view.getId();
      else var id = null;
      if (id) {
        var data = { view_id: view.getId() };
      } else {
        var data = {};
      }
      $.extend(data, obj._serialize());
      return data;
    };
    obj.serializeViewElem = _serialize;
    var state = 0;
    obj.setState = function (state) {
      state = state;
      obj.notify({ state: state });
    };
    obj.getState = function () {
      return state;
    };
    obj.setView = function (newView) {
      view = newView;
    };
    obj.getView = function () {
      return view;
    };
    return obj;
  };

  var ViewerMark = function () {
    var obj = MVCModelViewElem(ViewerMark);
    var transform = new Sculpteo3DViewerCommonTransform3D();
    obj.serialize = function () {
      var data = { transform: transform.toString() };
      $.extend(data, obj.serializeViewElem());
      return data;
    };
    obj.setTransform = function (newTransform) {
      transform = newTransform;
    };
    obj.getTransform = function () {
      return transform;
    };
    return obj;
  };

  ViewerMark.parse = function (data, elements) {
    checkModel(ViewerMark, data);
    var viewerMark = MVCModel._new(ViewerMark, data);
    viewerMark.setTransform(
      new Sculpteo3DViewerCommonTransform3D(data["transform"])
    );
    if (elements) elements.push(viewerMark);
    if (!data["channel"]) viewerMark.notifyCreated();
    return viewerMark;
  };

  var ViewerElem = function (type) {
    var obj = MVCModelViewElem(type);
    var x = 0;
    var y = 0;
    var _serialize = function () {
      var data = { x: x, y: y };
      $.extend(data, obj.serializeViewElem());
      return data;
    };
    obj.serializeElem = _serialize;
    obj._setPos = function (_x, _y) {
      x = _x;
      y = _y;
    };
    obj.setPos = function (_x, _y) {
      obj._setPos(_x, _y);
      obj.notify({ pos: [x, y] });
    };
    obj.getPos = function () {
      return [x, y];
    };
    obj.incrementPos = function (dx, dy) {
      obj.setPos(x + dx, y + dy);
    };
    return obj;
  };

  ViewerElem._parse = function (viewerElem, data) {
    viewerElem.setPos(data["x"], data["y"]);
    if (!data["channel"]) viewerElem.notifyCreated();
  };

  var ViewerCircle = function () {
    var obj = ViewerElem(ViewerCircle);
    var radius = 0;
    obj.serialize = function () {
      var data = { radius: radius };
      $.extend(data, obj.serializeElem());
      return data;
    };
    obj.setRadius = function (newRadius) {
      radius = newRadius;
    };
    obj.getRadius = function () {
      return radius;
    };
    obj.setPos = function (_x, _y, _r) {
      obj._setPos(_x, _y);
      if (_r && _r > 0) radius = _r;
      obj.notify({ pos: [_x, _y, radius] });
    };
    obj.incrementPos = function (dx, dy, dr) {
      var pos = obj.getPos();
      obj.setPos(pos[0] + dx, pos[1] + dy, radius + dr);
    };
    return obj;
  };

  ViewerCircle.parse = function (data, elements) {
    checkModel(ViewerCircle, data);
    var viewerCircle = MVCModel._new(ViewerCircle, data);
    viewerCircle.setRadius(data["radius"]);
    ViewerElem._parse(viewerCircle, data);
    if (elements) elements.push(viewerCircle);
    return viewerCircle;
  };

  var ViewerImage = function () {
    var obj = ViewerElem(ViewerImage);
    var imageSrc = "";
    obj.serialize = function () {
      var data = { src: imageSrc };
      $.extend(data, obj.serializeElem());
      return data;
    };
    obj.setImageSrc = function (src) {
      imageSrc = src;
      obj.notify({ src: src });
    };
    obj.getImageSrc = function () {
      return imageSrc;
    };
    return obj;
  };

  ViewerImage.parse = function (data, elements) {
    checkModel(ViewerImage, data);
    var viewerImage = MVCModel._new(ViewerImage, data);
    viewerImage.setImageSrc(data["src"]);
    ViewerElem._parse(viewerImage, data);
    if (elements) elements.push(viewerImage);
    return viewerImage;
  };

  var ViewerText = function () {
    var obj = ViewerElem(ViewerText);
    var text = "";
    obj.serialize = function () {
      var data = { description: text };
      $.extend(data, obj.serializeElem());
      return data;
    };
    obj.setText = function (newText) {
      text = newText;
      obj.notify({ text: newText });
    };
    obj.getText = function () {
      return text;
    };
    return obj;
  };

  ViewerText.parse = function (data, elements) {
    checkModel(ViewerText, data);
    var viewerText = MVCModel._new(ViewerText, data);
    viewerText.setText(data["description"]);
    ViewerElem._parse(viewerText, data);
    if (elements) elements.push(viewerText);
    return viewerText;
  };

  var View = function () {
    var obj = MVCModel(View);
    var name = "";
    var quat = null;
    var pan = null;
    var zoom = 1.0;
    var cutAxis = null;
    var viewerElems = [];
    var _viewer = null;
    var annotation = null;
    obj.serialize = function () {
      var data = {
        qw: quat[0],
        qx: quat[1],
        qy: quat[2],
        qz: quat[3],
        px: pan[0],
        py: pan[1],
        zoom: zoom,
        name: name,
      };
      if (cutAxis) {
        data.cut_axis = cutAxis.serialize();
      }
      data.components = [];
      for (var i = 0; i < viewerElems.length; i++) {
        data.components.push(viewerElems[i].serialize());
      }
      if (annotation && annotation.getId()) {
        data.annotation_id = annotation.getId();
      }
      $.extend(data, obj._serialize());
      return data;
    };
    obj.setAnnotation = function (newAnnotation) {
      annotation = newAnnotation;
    };
    obj.addViewerElem = function (viewerElem) {
      if (viewerElem.getView() == obj) return;
      viewerElems.push(viewerElem);
      viewerElem.setView(obj);
      obj.notify({ add: viewerElem });
    };
    obj.removeViewerElem = function (viewerElem) {
      var idx = viewerElems.indexOf(viewerElem);
      viewerElems.splice(idx, 1);
      viewerElem.setView(null);
      obj.notify({ remove: viewerElem });
    };
    obj.removeViewerElems = function () {
      var dup = viewerElems.slice();
      for (var i = 0; i < dup.length; i++) {
        obj.removeViewerElem(dup[i]);
      }
    };
    obj.getViewerElems = function () {
      return viewerElems.slice();
    };
    obj.setQuat = function (newQuat) {
      quat = newQuat;
    };
    obj.setPan = function (newPan) {
      pan = newPan;
    };
    obj.setName = function (newName) {
      name = newName;
    };
    obj.getName = function () {
      return name;
    };
    obj.setZoom = function (newZoom) {
      zoom = newZoom;
    };
    obj.setCutAxis = function (newCutAxis) {
      cutAxis = newCutAxis;
    };
    obj.orientViewer = function (viewer, callback) {
      if (quat && pan && zoom) {
        resetIgnoreCounter();
        //promise = viewer.animateCamera(quat,
        //pan, zoom, 0);
        var dstQ = Sculpteo3DViewerTransform3D.quatNormalize(quat);
        var viewerInst = viewer._getViewerInstance();
        setAnimating(true);
        viewer.animateCamera(quat, pan, zoom, 400, "swing", function () {
          setTimeout(function () {
            setAnimating(false);
          }, 20);
        });
        //viewerInst.setZoom(zoom, marker);
        //viewerInst.setPan(pan[0], pan[1], marker);
        //viewerInst.setTransform(dstQ.join(','));
      }
      _viewer = viewer;
      if (cutAxis) cutAxis.cutViewer(viewer);
      else obj.clearViewer();
    };
    obj.clearViewer = function () {
      if (_viewer) _viewer.clrCutAxis();
    };
    obj.useViewerOrient = function (viewer) {
      var _quat = viewer.getTransform().split(",");
      quat = [
        parseFloat(_quat[0]),
        parseFloat(_quat[1]),
        parseFloat(_quat[2]),
        parseFloat(_quat[3]),
      ];
      var _pan = viewer.getPan();
      pan = [_pan.x, _pan.y];
      zoom = viewer.getZoom();
    };
    obj.cleanup = function () {
      obj._cleanup();
      if (cutAxis) cutAxis.cleanup();
      for (var i = 0; i < viewerElems.length; i++) {
        viewerElems[i].cleanup();
      }
    };
    obj.setState = function (state) {
      for (var i = 0; i < viewerElems.length; i++) {
        viewerElems[i].setState(state);
      }
    };
    return obj;
  };

  View.parse = function (data, elements) {
    checkModel(View, data);
    var view = MVCModel._new(View, data);
    view.setName(data["name"]);
    view.setQuat([data["qw"], data["qx"], data["qy"], data["qz"]]);
    view.setPan([data["px"], data["py"]]);
    view.setZoom(data["zoom"]);
    if (data["cut_axis"])
      view.setCutAxis(CutAxis.parse(data["cut_axis"], elements));
    if (!data["channel"]) view.notifyCreated();
    var components = data["components"];
    var oldViewElems = view.getViewerElems();
    for (var i = 0; i < oldViewElems.length; i++) {
      var elem = oldViewElems[i];
      elem.isIn = 0;
    }
    for (var i = 0; i < components.length; i++) {
      var model = typeMap[components[i]["annotation_type"]];
      var component = model.parse(components[i], elements);
      view.addViewerElem(component);
      component.isIn = 1;
    }
    for (var i = 0; i < oldViewElems.length; i++) {
      var elem = oldViewElems[i];
      if (!elem.isIn) view.removeViewerElem(elem);
    }
    if (elements) {
      elements.push(view);
    }
    return view;
  };

  var annotation_count = 0;
  var Annotation = function () {
    var obj = MVCModel(Annotation);
    annotation_count += 1;
    var this_count = annotation_count;
    var name = "Annotation" + this_count;
    var text = "";
    var views = [];
    var respondTo = null;
    var state = gettext("editing");
    var dtime = "";
    var ctime = "";
    var needReview = 0;
    var isCustomer = !canSetPending;

    obj.serialize = function () {
      var data = { name: name, description: text, state: state };
      if (respondTo) data.respond_to = respondTo;
      data.views = [];
      for (var i = 0; i < views.length; i++) {
        data.views.push(views[i].serialize());
      }
      $.extend(data, obj._serialize());
      return data;
    };

    obj.setState = function (newState) {
      for (var i = 0; i < views.length; i++) {
        views[i].setState(newState);
      }
      if (newState == 0) state = gettext("draft");
      else if (newState == 1) {
        state = gettext("edited");
      } else if (newState == 2) {
        state = gettext("pending");
        obj.setReadOnly(true);
      } else if (newState == 3) {
        state = gettext("read");
        obj.setReadOnly(true);
      } else if (newState == 4) {
        state = gettext("closed");
        obj.setReadOnly(true);
      }
      obj.notify({ state: state, state_id: newState });
    };
    obj.setNeedReview = function (newNeedReview) {
      needReview = newNeedReview;
    };
    obj.needReview = function () {
      return needReview;
    };
    obj.setIsCustomer = function (newIsCustomer) {
      isCustomer = newIsCustomer;
    };
    obj.isCustomer = function () {
      return isCustomer;
    };
    obj.getState = function () {
      return state;
    };
    obj.getDtime = function () {
      return dtime;
    };
    obj.setDtime = function (newDtime) {
      if (newDtime) {
        dtime = newDtime;
        obj.setReadOnly(true);
        obj.notify({ dtime: newDtime });
      }
    };
    obj.setCtime = function (newCtime) {
      ctime = newCtime;
      obj.notify({ ctime: ctime });
    };
    obj.getCtime = function () {
      return ctime;
    };
    obj.setRespondTo = function (id) {
      if (id) {
        respondTo = id;
        obj.notify({ respondTo: id });
      }
    };
    obj.getRespondTo = function () {
      return respondTo;
    };
    obj.setName = function (newName) {
      name = newName;
      obj.notify({ name: newName });
    };
    obj.getName = function () {
      return name;
    };
    obj.addView = function (view) {
      views.push(view);
      view.setAnnotation(obj);
      obj.notify({ add: view });
    };
    obj.removeViews = function () {
      views = [];
      obj.notify({ remove: true });
    };
    obj.getViews = function () {
      return views;
    };
    obj.setText = function (newText) {
      text = newText;
      obj.notify({ text: newText });
    };
    obj.getText = function () {
      return text;
    };
    obj.getUiId = function () {
      return obj.channel;
    };
    var _this = this;
    obj.cleanup = function () {
      obj._cleanup();
      for (var i = 0; i < views.length; i++) {
        views[i].cleanup();
      }
    };
    return obj;
  };

  Annotation.parse = function (data, elements, respondToList) {
    var annotation = MVCModel._new(Annotation, data);
    annotation.setName(data["name"]);
    annotation.setText(data["description"]);
    annotation.setCtime(data["ctime"]);
    annotation.setNeedReview(data["to_review"]);
    annotation.setIsCustomer(data["customer"]);
    if (!data["channel"]) annotation.notifyCreated();
    if (data["respond_to"])
      respondToList[annotation.channel] = data["respond_to"];
    //annotation.setRespondTo(data["respond_to"]);
    var views = data["views"];
    annotation.removeViews();
    for (var i = 0; i < views.length; i++) {
      var view = View.parse(views[i]);
      annotation.addView(view, elements);
    }
    if (elements) {
      elements.push(annotation);
    }
    if (data["dtime"]) {
      annotation.setDtime(data["dtime"]);
    } else {
      annotation.setState(data["state"]);
    }
    return annotation;
  };

  var setTypes = function (
    annotationType,
    viewType,
    viewerTextType,
    viewerCircleType,
    viewerMarkType,
    cutAxisType,
    viewerImageType
  ) {
    setTypeForModel(
      Annotation,
      annotationType,
      AnnotationUI,
      AnnotationCtrl,
      AnnotationCtrlReadOnly
    );
    setTypeForModel(View, viewType, ViewUI, ViewCtrl, ViewCtrlReadOnly);
    setTypeForModel(ViewerText, viewerTextType, ViewerTextUI, ViewerTextCtrl);
    setTypeForModel(
      ViewerCircle,
      viewerCircleType,
      ViewerCircleUI,
      ViewerCircleCtrl
    );
    setTypeForModel(ViewerMark, viewerMarkType, ViewerMarkUI, ViewerMarkCtrl);
    setTypeForModel(CutAxis, cutAxisType);
    setTypeForModel(
      ViewerImage,
      viewerImageType,
      ViewerImageUI,
      ViewerImageCtrl,
      ViewerImageCtrlRo
    );
  };

  //Views

  var MVCView = function (model, rootUI) {
    var obj = {};
    var listeners = [];
    obj.subscribe = function (listener) {
      listeners.push(listener);
      $.Topic(model.channel).subscribe(listener);
    };
    obj.unsubscribe = function () {
      for (var i = 0; i < listeners.length; i++) {
        $.Topic(model.channel).unsubscribe(listeners[i]);
      }
    };
    obj.rootUI = rootUI;
    model.viewObj = obj;
    obj.getModel = function () {
      return model;
    };
    obj.key = Utils.uniqueString();
    obj.detach = function () {};
    obj.subscribe(function (data) {
      if (data.deleted) {
        obj.detach();
        obj.unsubscribe();
      }
    });
    obj.attachTo = function (elem) {};
    return obj;
  };

  var _coneNode = null;
  var _newConeNode = function (viewerUI, callback) {
    var bbox = viewerUI.viewer._getViewerInstance()._mesh_bbox;
    if (bbox) {
      var x = bbox[3] - bbox[0];
      var y = bbox[4] - bbox[1];
      var z = bbox[5] - bbox[2];
      var dim = (x + y + z) / 3;
      var pow = Math.log(dim) / Math.log(10);
      var fact = Math.pow(10, pow - 1);
    } else {
      var fact = 1;
    }
    var dfd = viewerUI.init_cone_node(fact, "3dmark_cone_node", true);
    if (_coneNode) {
      callback(_coneNode);
    } else {
      dfd.then(function () {
        _coneNode = dfd.cone_node;
        _coneNode.setMaterial(viewerUI.get_cursor_material());
        _coneNode.setDrawMode(Sculpteo3DViewerSceneNode.DRAWMODE_FLAT);
        callback(_coneNode);
      });
    }
  };
  var newConeNode = function (viewerUI, transform, callback) {
    var viewer = viewerUI.viewer;
    _newConeNode(viewerUI, function (coneNode) {
      var newNode = viewer.createNode(coneNode.id, transform);
      newNode.setFlags("C:AO");
      newNode.setMaterial(viewerUI.get_cursor_material());
      viewer.updateSceneTransform();
      callback(newNode);
    });
  };

  var ViewerMarkUI = function (viewerMark, viewerUI, rootUI) {
    var obj = MVCView(viewerMark, rootUI);
    var nodeAvailable = $.Deferred();
    var setNode = function (node) {
      nodeAvailable.node = node;
      nodeAvailable.resolve();
    };
    newConeNode(viewerUI, viewerMark.getTransform(), setNode);
    obj.attach = function () {
      //viewerUI.viewer.setLocal(true);
      nodeAvailable.then(function () {
        var m = viewerUI.viewer.getScene();
        m.appendChild(nodeAvailable.node);
      });
    };
    obj.detach = function () {
      nodeAvailable.then(function () {
        nodeAvailable.node.detach();
      });
    };
    obj.applyToNode = function (callback) {
      nodeAvailable.then(function () {
        callback(nodeAvailable.node);
      });
    };
    obj.cleanup = function () {
      nodeAvailable.then(function () {
        nodeAvailable.destruct();
      });
    };
    return obj;
  };

  var roundN = function (number, n) {
    return Math.round(number * n) / n;
  };
  var roundUI = function (number) {
    return roundN(number, 1000);
  };

  var ViewerElemUI = function (viewerElem, viewerUI, rootUI) {
    var viewer = viewerUI.viewer;
    var root = $("#annotation-editor-widget");
    var obj = MVCView(viewerElem, rootUI);
    var viewerTextRoot = $("<div>");
    viewerTextRoot.addClass("mesh-text");
    var viewerOffset = viewer.$jself.offset();
    var side = Math.min(viewer.getWidth(), viewer.getHeight());
    var center = { x: viewer.getWidth() / 2, y: viewer.getHeight() / 2 };
    obj.side = side;
    obj.setPos = function (x, y, r) {
      viewerElem.setPos(
        roundUI((x - center.x) / side),
        roundUI((y - center.y) / side),
        roundUI(r / side)
      );
    };
    obj.getPos = function () {
      var pos = viewerElem.getPos();
      return [pos[0] * side + center.x, pos[1] * side + center.y];
    };
    obj.incrementPos = function (dx, dy) {
      var pos = obj.getPos();
      obj.setPos(pos[0] + dx, pos[1] + dy);
    };
    var updatePos = function () {
      var pos = obj.getPos();
      var offset = {
        top: viewerOffset.top + pos[1],
        left: viewerOffset.left + pos[0],
      };
      viewerTextRoot.offset(offset);
    };
    obj.subscribe(updatePos);
    updatePos();
    obj.attach = function () {
      root.append(viewerTextRoot);
      updatePos();
    };
    obj.detach = function () {
      viewerTextRoot.detach();
    };
    obj.getRoot = function () {
      return viewerTextRoot;
    };
    obj.getDragRoot = function () {
      return root;
    };
    obj.getDraggable = function () {
      return viewerTextRoot;
    };
    obj.getViewerElem = function () {
      return viewerElem;
    };
    return obj;
  };

  var ViewerCircleUI = function (viewerCircle, viewerUI, rootUI) {
    var obj = ViewerElemUI(viewerCircle, viewerUI, rootUI);
    var viewer = viewerUI.viewer;
    var _canvas = document.createElement("canvas");
    var canvas = $(_canvas);
    var viewerTextRoot = obj.getRoot();
    viewerTextRoot.append(canvas);
    var enlargeBtn = $("<button>");
    enlargeBtn.addClass("viewer-circle-enlarge");
    obj.getRadius = function () {
      return obj.side * viewerCircle.getRadius();
    };
    obj.setRadius = function (r) {
      viewerCircle.setRadius(roundUI(r / obj.side));
    };
    obj.incrementPos = function (dx, dy, dr) {
      var pos = obj.getPos();
      obj.setPos(pos[0] + dx, pos[1] + dy, obj.getRadius() + dr);
    };
    obj.getDraggable = function () {
      return canvas;
    };
    var offsetBtn = function () {
      var rootOffset = viewerTextRoot.offset();
      var r = obj.getRadius();
      var offset = {
        top: rootOffset.top + 2 * r,
        left: rootOffset.left + 2 * r,
      };
      enlargeBtn.offset(offset);
    };
    obj.getEnlargeBtn = function () {
      return enlargeBtn;
    };
    offsetBtn();
    var drawCircle = function () {
      var r = obj.getRadius();
      var offCanvas = document.createElement("canvas");
      offCanvas.width = 2 * r + 5;
      offCanvas.height = 2 * r + 5;
      var ctx = offCanvas.getContext("2d");
      var path = new Path2D();
      path.arc(r + 2, r + 2, r, 0, 2 * Math.PI);
      ctx.lineWidth = 5;
      ctx.strokeStyle = "#4499ee";
      ctx.stroke(path);
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#eeeeee";
      ctx.stroke(path);
      var ctx_ = _canvas.getContext("2d");
      ctx_.clearRect(0, 0, 2 * r + 5, 2 * r + 5);
      _canvas.width = 2 * r + 5;
      _canvas.height = 2 * r + 5;
      ctx_.drawImage(offCanvas, 0, 0);
      offsetBtn();
    };
    drawCircle();
    obj.subscribe(drawCircle);
    var deleteBtn = $("<button>");
    deleteBtn.text("×");
    deleteBtn.addClass("delete-elem-btn");
    if (!viewerCircle.readOnly()) {
      viewerTextRoot.append(enlargeBtn);
      viewerTextRoot.append(deleteBtn);
    }
    obj.subscribe(function (data) {
      if (data.state && data.state >= 2) {
        deleteBtn.detach();
        enlargeBtn.detach();
      }
    });
    obj.getDelBtn = function () {
      return deleteBtn;
    };
    return obj;
  };

  var ViewerImageUI = function (viewerImage, viewerUI, rootUI) {
    var obj = ViewerElemUI(viewerImage, viewerUI, rootUI);
    var icon = $("<label>");
    icon.addClass("imageTag");
    icon.css("background-image", "url('" + viewerImage.getImageSrc() + "')");
    obj.getRoot().append(icon);
    var deleteBtn = $("<button>");
    deleteBtn.text("×");
    deleteBtn.addClass("delete-elem-btn");
    if (!viewerImage.readOnly()) {
      obj.getRoot().append(deleteBtn);
    }
    obj.getDelBtn = function () {
      return deleteBtn;
    };
    var smallImage = $("<img>");
    smallImage.height(30);
    smallImage.attr("src", viewerImage.getImageSrc());
    var image = $("<div>");
    image.css("background-image", "url('" + viewerImage.getImageSrc() + "')");
    image.addClass("big-img");
    var closeBtn = $("<button>");
    closeBtn.text("×");
    closeBtn.addClass("delete-elem-btn");
    image.append(closeBtn);
    obj.getCloseBtn = function () {
      return closeBtn;
    };
    obj.subscribe(function (data) {
      if (data.src) {
        image.prop("background-image", "url('" + data.src + "')");
        smallImage.attr("src", data.src);
      } else if (data.state && data.state >= 2) {
        deleteBtn.detach();
      }
    });
    obj.getDraggable = function () {
      return icon;
    };
    obj.attachTo = function (elem) {
      elem.append(smallImage);
    };
    obj.getSmallImage = function () {
      return icon;
    };
    obj.cleanup = function () {
      smallImage.detach();
    };
    obj.getImage = function () {
      return image;
    };
    obj.showImage = function () {
      $("#annotation-editor-widget").append(image);
    };
    obj.hideImage = function () {
      image.detach();
    };
    return obj;
  };

  var ViewerTextUI = function (viewerText, viewerUI, rootUI) {
    var obj = ViewerElemUI(viewerText, viewerUI, rootUI);
    var viewer = viewerUI.viewer;
    var viewerTextRoot = obj.getRoot();
    var label = null;
    label = $("<textarea>");
    label.addClass("mesh-text");
    label.text(viewerText.getText());
    if (viewerText.readOnly()) label.attr("readonly", "readonly");
    viewerTextRoot.append(label);
    var deleteBtn = $("<button>");
    deleteBtn.text("×");
    deleteBtn.addClass("delete-elem-btn");
    if (!viewerText.readOnly()) {
      viewerTextRoot.append(deleteBtn);
    }
    obj.subscribe(function (data) {
      if (data.state && data.state >= 2) {
        deleteBtn.detach();
        label.attr("readonly", "readonly");
      } else if (data.text) {
        label.text(data.text);
      }
    });
    obj.getDraggable = function () {
      return label;
    };
    obj.getDelBtn = function () {
      return deleteBtn;
    };
    obj.getLabel = function () {
      return label;
    };
    return obj;
  };

  var ViewUI = function (view, viewerUI, rootUI) {
    var obj = MVCView(view, rootUI);
    var rack = $("<div>");
    var btn = $("<button>");
    btn.text(view.getName());
    var viewerElemUIs = {};
    obj.pushViewerElemUI = function (key, viewerElemUI) {
      viewerElemUIs[key] = viewerElemUI;
      //viewerElemUI.attachTo(rack);
    };
    //var addAllViewElems = function(){
    //var viewerElems = view.getViewerElems();
    //for(var i = 0; i < viewerElems.length; i++){
    //var viewerElem = viewerElems[i];
    //obj.pushViewerElemUI(viewerElem.channel,
    //new ViewerElemUI(viewerElem, viewer));
    //}
    //}
    var removeViewElems = function () {
      for (var key in viewerElemUIs) {
        var viewerElemUI = viewerElemUIs[key];
        viewerElemUI.detach();
      }
    };
    obj.getViewerElemUIs = function () {
      return viewerElemUIs;
    };
    obj.getViewRoot = function () {
      return rack;
    };
    obj.detach = function () {
      removeViewElems();
      view.clearViewer();
    };
    obj.show = function (viewer, callback) {
      for (var key in viewerElemUIs) {
        var viewerElemUI = viewerElemUIs[key];
        viewerElemUI.attach();
      }
      view.orientViewer(viewer, callback);
    };
    //addAllViewElems();
    obj.subscribe(function (data) {
      if (data.add) {
        var viewerElem = data.add;
        obj.pushViewerElemUI(viewerElem.channel, viewerElem.viewObj);
        if (obj.is_active) viewerElem.viewObj.attach();
      } else if (data.remove) {
        var viewerElem = data.remove;
        var viewerElemUI = viewerElemUIs[viewerElem.channel];
        viewerElemUI.detach();
        delete viewerElemUIs[viewerElem.channel];
      }
    });
    return obj;
  };

  var anchors = [];

  var AnnotationAnchor = function (offset, annotation) {
    var obj = {};
    obj.annotation = annotation;
    obj.offset = offset;
    obj.distance = function (newOffset) {
      return Math.sqrt(
        Math.pow(obj.offset.top - newOffset.top, 2) +
          Math.pow(obj.offset.left - newOffset.left, 2)
      );
    };
    obj.setRespondTo = function (newAnnotation) {
      newAnnotation.setRespondTo(obj.annotation.getId());
    };
    anchors.push(obj);
    return obj;
  };

  var AnnotationUI = function (annotation, viewerUI, rootUI) {
    var obj = MVCView(annotation, rootUI);
    var uiId = annotation.getUiId();
    var annotationRoot = $("<div>");
    annotationRoot.addClass("annotation-root");
    var selectionContainer = $("<div>");
    selectionContainer.addClass("selection-container");
    //selectionContainer.addClass('annotation-width');
    var htmlString = '<div id="annotation-' + uiId + '">';
    var annotationContainer = $(htmlString);
    //annotationContainer.addClass('annotation-width');
    annotationContainer.addClass("annotation");
    if (annotation.needReview()) {
      annotationContainer.addClass("review-notif");
    }
    if (annotation.isCustomer()) {
      annotationContainer.addClass("customer-annotation");
    } else {
      annotationContainer.addClass("sculpteo-annotation");
    }
    var saveAnnotationCont = $("<div>");
    saveAnnotationCont.addClass("save-annotation-container");
    var saveAnnotation = $("<button/>");
    saveAnnotation.text(gettext("OK"));
    saveAnnotation.addClass("save-annotation");
    saveAnnotation.addClass("blue-button");
    saveAnnotationCont.append(saveAnnotation);
    var ctimeLabel = $("<label>");
    ctimeLabel.text(annotation.getCtime());
    ctimeLabel.addClass("annotation-name");
    //ctimeLabel.addClass('annotation-width');
    var nameInp = $("<input>");
    nameInp.addClass("annotation-name");
    nameInp.val(annotation.getName());
    //nameInp.addClass('annotation-width');
    var viewRacks = $("<div>");
    var authorLbl = $("<label>");
    authorLbl.text(annotation.getAuthor());
    authorLbl.addClass("author");
    var dragBtn = $("<button>");
    dragBtn.text("");
    dragBtn.addClass("annotation-drag");
    var delBtn = $("<button>");
    delBtn.addClass("annotation-delete");
    delBtn.text("×");
    var widgetList = $("<div>");
    widgetList.addClass("annotation-name");
    var responseRoot = $("<div>");
    responseRoot.addClass("response-list");
    var textElem = $("<textarea>");
    textElem.text(annotation.getText());
    //textElem.addClass('annotation-width');
    textElem.addClass("annotation-name");
    //annotationContainer.append(dragBtn);
    obj.getDraggable = function () {
      return dragBtn;
    };
    annotationContainer.append(ctimeLabel);
    if (annotation.readOnly()) {
      textElem.attr("disabled", "disabled");
      textElem.attr("readonly", "readonly");
      annotationContainer.addClass("annotation-disabled");
    } else {
      textElem.addClass("annotation-name-active");
      annotationContainer.append(delBtn);
    }
    annotationContainer.append(textElem);
    if (annotation.getState() == gettext("editing")) {
      annotationContainer.append(saveAnnotationCont);
    }
    annotationContainer.append(viewRacks);
    //annotationContainer.append(authorLbl);
    annotationContainer.append(widgetList);
    selectionContainer.append(annotationContainer);
    annotationRoot.append(selectionContainer);
    annotationRoot.append(responseRoot);
    rootUI.append(annotationRoot);
    obj.removeFromResponse = function () {
      rootUI.append(annotationRoot);
    };
    var initialOffset = annotationRoot.offset();
    var anchor = new AnnotationAnchor(initialOffset, annotation);
    //annotationRoot.append(textElem);
    //var viewsElem = $('<div>');
    var views = annotation.getViews();
    var viewUIs = [];
    obj.pushViewUI = function (viewUI) {
      viewUIs.push(viewUI);
      viewRacks.append(viewUI.getViewRoot());
    };
    //for(var i = 0; i < views.length; i++){
    //var viewUI = new ViewUI(views[i]);
    //pushViewUI(viewUI);
    //}
    //annotationRoot.append(viewsElem);
    obj.getAnnotation = function () {
      return annotation;
    };
    obj.addResponseAnnotation = function (annotationUI) {
      responseRoot.append(annotationUI.getAnnotationRoot());
    };
    obj.removeReview = function () {
      annotationContainer.removeClass("review-notif");
    };
    obj.getViewsRoot = function () {
      return viewsElem;
    };
    obj.getViewsElem = function () {
      return viewUIs;
    };
    obj.getTextElem = function () {
      //return nameInp;
      return textElem;
    };
    obj.getSaveElem = function () {
      return saveAnnotation;
    };
    obj.getDeleteElem = function () {
      return delBtn;
    };
    obj.getNameElem = function () {
      return nameLbl;
    };
    obj.getAnnotationRoot = function () {
      return annotationRoot;
    };
    obj.getAnnotationContainer = function () {
      return annotationContainer;
    };
    obj.getSelectionContainer = function () {
      return selectionContainer;
    };
    obj.getSave = function () {
      return saveAnnotation;
    };
    obj.detach = function () {
      annotationRoot.detach();
      for (var i = 0; i < viewUIs.length; i++) {
        viewUIs[i].detach();
      }
    };
    obj.getInitialOffset = function () {
      return initialOffset;
    };
    obj.subscribe(function (data) {
      if (data.add) {
        var view = data.add;
        obj.pushViewUI(view.viewObj);
        //viewsElem.append(view.viewObj.getViewRoot());
      } else if (data.state) {
        // TODO determine if staff
        if (canSetPending) {
          $(annotationRoot).removeClass(
            "annotation-state-" + annotation.getState()
          );
          $(annotationRoot).addClass("annotation-state-" + data.state);
        }
        //stateLabel.text(data.state);
        if (data.state_id >= 2) {
          textElem.attr("disabled", "disabled");
          textElem.attr("readonly", "readonly");
          annotationContainer.addClass("annotation-disabled");
          nameInp.attr("disabled", "disabled");
        }
        saveAnnotation.detach();
      } else if (data.dtime) {
        ctimeLabel.text("deleted: " + data.dtime);
        textElem.attr("disabled", "disabled");
        textElem.attr("readonly", "readonly");
        textElem.val("");
        annotationContainer.addClass("annotation-disabled");
        delBtn.detach();
        saveAnnotation.detach();
      } else if (data.ctime) {
        ctimeLabel.text(data.ctime);
      } else if (data.respondTo) {
        var annotationUI = getUIFromId(data.respondTo);
        annotationUI.addResponseAnnotation(obj);
        initialOffset = annotationRoot.offset();
        anchor.offset = initialOffset;
      } else if (data.remove) {
        viewUIs = [];
      } else if (data.name) {
        nameInp.val(annotation.getName());
      } else if (data.author) {
        authorLbl.text(data.author);
      } else if (data.text) {
        textElem.text(data.text);
      }
    });
    return obj;
  };

  //Controller

  var APICtrl = function (design_uuid) {
    var obj = {};
    var updateQueue = {};
    var updateTimeoutId = null;
    var postUpdate = function () {
      var annotations = [];
      for (var key in updateQueue) {
        annotations.push(updateQueue[key]);
      }
      updateQueue = {};
      $.post(
        URLS["annotation_api"],
        {
          uuid: design_uuid,
          annotations: JSON.stringify(annotations),
          op: "u",
        },
        function (data) {
          data = data.data;
          if (data.error) return;
          for (var key in data) {
            var channel = idMap[key];
            var elem = modelElements[channel];
            if (elem.getType() == Annotation) elem.setState(1);
          }
        }
      );
    };
    obj.queueUpdate = function (model) {
      if (model.getId()) {
        updateQueue[model.channel] = model.serialize();
        if (updateTimeoutId) clearTimeout(updateTimeoutId);
        updateTimeoutId = setTimeout(postUpdate, 1000);
      }
    };
    obj.getModel = function (callback, callback_err) {
      $.get(
        URLS["annotation_api"],
        {
          uuid: design_uuid,
          mark_as_read: markAsRead,
        },
        function (response) {
          lastTimeStamp = response.timestamp;
          response = response.data;
          if (response.error && callback_err) {
            callback_err(response.error);
          } else if (callback && !response.error) {
            callback(response);
          }
        }
      );
    };
    obj.postNewState = function (
      annotation_ids,
      newState,
      callback,
      callback_err
    ) {
      $.post(
        URLS["annotation_state_api"],
        {
          uuid: design_uuid,
          annotations: JSON.stringify(annotation_ids),
          state: newState,
        },
        function (response) {
          response = response.data;
          if (response.error && callback_err) {
            callback_err(response.error);
          } else if (callback && !response.error) {
            callback(response);
          }
        }
      );
    };
    return obj;
  };

  var MVCCtrl = function (model) {
    var obj = {};
    obj.rootCtrl = null;
    obj.setRootCtrl = function (newRootCtrl) {
      obj.rootCtrl = newRootCtrl;
    };
    var modelInDB = function () {
      if (model.getId()) return true;
      else return false;
    };
    obj.postModel = function (callback, callback_err) {
      $.post(
        URLS["annotation_api"],
        {
          uuid: obj.rootCtrl.design_uuid,
          op: "c",
          annotations: JSON.stringify([model.serialize()]),
        },
        function (response) {
          response = response.data;
          var response = response[0];
          if (response.error && callback_err) {
            callback_err(response.error);
          } else if (callback && !response.error) {
            callback(response);
            if (model.getType() == Annotation && !canSetPending)
              if (model.getRespondTo())
                zopimSay(gettext("I replied to an existing annotation"));
              else zopimSay(gettext("I added a new annotation to the design"));
          }
        }
      );
    };
    obj.deleteModel = function (callback, callback_err) {
      if (modelInDB()) {
        $.post(
          URLS["annotation_api"],
          {
            uuid: obj.rootCtrl.design_uuid,
            op: "d",
            annotations: JSON.stringify([model.getId()]),
          },
          function (response) {
            response = response.data;
            if (response.error && callback_err) {
              callback_err(response.error);
            } else if (callback && !response.error) {
              callback(response);
            }
          }
        );
      } else {
        callback();
      }
    };
    return obj;
  };

  var setDraggable = function (
    elem,
    dragCallback,
    hasReset,
    root,
    stopDragCallback
  ) {
    var dragActive = false;
    var _x_orig = 0;
    var _y_orig = 0;
    var x_orig = 0;
    var y_orig = 0;
    var dragTo = function (evt) {
      if (dragActive) {
        evt.preventDefault();
        evt.stopPropagation();
        var dx = evt.pageX - x_orig;
        var dy = evt.pageY - y_orig;
        x_orig = evt.pageX;
        y_orig = evt.pageY;
        dragCallback(dx, dy, evt);
      }
    };
    var stopDrag = function (evt) {
      if (stopDragCallback) stopDragCallback(evt);
      dragActive = false;
      x_orig = 0;
      y_orig = 0;
      root.unbind("mousemove", dragTo);
      root.unbind("mouseup", stopDrag);
      root.unbind("mouseleave", resetDrag);
    };
    var resetDrag = function (evt) {
      if (hasReset) {
        dragCallback(_x_orig - x_orig, _y_orig - y_orig);
      }
      stopDrag(evt);
    };
    var startDrag = function (evt) {
      dragActive = true;
      x_orig = evt.pageX;
      y_orig = evt.pageY;
      _x_orig = evt.pageX;
      _y_orig = evt.pageY;
      root.bind("mouseup", stopDrag);
      root.bind("mousemove", dragTo);
      root.bind("mouseleave", resetDrag);
    };
    elem.bind("mousedown", startDrag);
    return function () {
      elem.unbind("mousedown", startDrag);
    };
  };

  var ElemCtrl = function (elemUI) {
    var obj = MVCCtrl(elemUI.getModel());
    obj.cleanup = function () {
      obj.deleteModel(function () {
        elemUI.detach();
        var model = elemUI.getModel();
        var view = model.getView();
        if (view) view.removeViewerElem(model);
      });
    };
    return obj;
  };

  var ViewerMarkCtrl = function (viewerMarkUI) {
    var obj = ElemCtrl(viewerMarkUI);
    viewerMarkUI.applyToNode(function (node) {
      node.addEventListener("click", obj.cleanup);
    });
    viewerMarkUI.subscribe(function (data) {
      if (data.state && data.state >= 2) {
        viewerMarkUI.applyToNode(function (node) {
          node.removeEventListener("click", obj.cleanup);
        });
      }
    });
    return obj;
  };

  var ViewerElemCtrl = function (viewerElemUI) {
    var obj = ElemCtrl(viewerElemUI);
    var pos = viewerElemUI.getViewerElem().getPos();
    var label = viewerElemUI.getDraggable();
    label.bind("input propertychange", function () {
      viewerElemUI.getViewerElem().setText(label.val());
      obj.rootCtrl.apiCtrl.queueUpdate(viewerElemUI.getModel());
    });
    var dragCallback = function (dx, dy) {
      viewerElemUI.incrementPos(dx, dy);
      obj.rootCtrl.apiCtrl.queueUpdate(viewerElemUI.getModel());
    };
    var stopDrag = setDraggable(
      label,
      dragCallback,
      true,
      viewerElemUI.getDragRoot()
    );
    viewerElemUI.subscribe(function (data) {
      if (data.state && data.state >= 2) {
        stopDrag();
      }
    });
    return obj;
  };

  var ViewerCircleCtrl = function (viewerCircleUI) {
    var obj = ViewerElemCtrl(viewerCircleUI);
    var viewerCircle = viewerCircleUI.getViewerElem();
    var enlargeBtn = viewerCircleUI.getEnlargeBtn();
    setDraggable(
      enlargeBtn,
      function (dx, dy) {
        if (Math.abs(dx) < Math.abs(dy)) {
          viewerCircleUI.incrementPos(0, 0, dx);
        } else {
          viewerCircleUI.incrementPos(0, 0, dy);
        }
        obj.rootCtrl.apiCtrl.queueUpdate(viewerCircleUI.getModel());
      },
      false,
      viewerCircleUI.getDragRoot()
    );
    var delBtn = viewerCircleUI.getDelBtn();
    delBtn.click(obj.cleanup);
    return obj;
  };

  var ViewerImageCtrlRo = function (viewerImageUI) {
    var obj = MVCCtrl(viewerImageUI);
    var closeBtn = viewerImageUI.getCloseBtn();
    var oldxy = [0, 0];
    viewerImageUI.getSmallImage().mousedown(function (event) {
      oldxy[0] = event.pageX;
      oldxy[1] = event.pageY;
    });
    viewerImageUI.getSmallImage().mouseup(function (event) {
      if (
        Math.abs(oldxy[0] - event.pageX) <= 5 &&
        Math.abs(oldxy[1] - event.pageY) <= 5
      ) {
        event.stopPropagation();
        viewerImageUI.showImage();
      }
    });
    viewerImageUI.getImage().mousemove(function (event) {
      event.stopPropagation();
    });
    closeBtn.click(function (event) {
      event.stopPropagation();
      event.preventDefault();
      viewerImageUI.hideImage();
    });
    return obj;
  };

  var ViewerImageCtrl = function (viewerImageUI) {
    var obj = ViewerElemCtrl(viewerImageUI);
    ViewerImageCtrlRo(viewerImageUI);
    var delBtn = viewerImageUI.getDelBtn();
    delBtn.click(function () {
      obj.cleanup();
      viewerImageUI.cleanup();
    });
    return obj;
  };

  var ViewerTextCtrl = function (viewerTextUI) {
    var obj = ViewerElemCtrl(viewerTextUI);
    var delBtn = viewerTextUI.getDelBtn();
    delBtn.click(obj.cleanup);
    return obj;
  };

  var ViewCtrlReadOnly = function (viewUI, viewerUI) {
    var view = viewUI.getModel();
    var obj = MVCCtrl(view);
    var viewer = viewerUI.viewer;
    obj.show = function () {
      obj.rootCtrl.setViewActive(viewUI);
      viewUI.show(viewer);
    };
    viewUI.getViewRoot().click(function (evt) {
      obj.show();
    });
    return obj;
  };

  var ViewCtrl = function (viewUI, viewerUI) {
    var obj = ViewCtrlReadOnly(viewUI, viewerUI);
    var view = viewUI.getModel();
    var viewer = viewerUI.viewer;
    obj.pushViewerElem = function (viewerElemUI) {
      var viewerElem = viewerElemUI.getModel();
      view.addViewerElem(viewerElem);
    };
    obj.updateViewerData = function () {
      view.useViewerOrient(viewerUI.viewer);
      var cutAxisData = viewer.getCutAxis();
      if (cutAxisData) {
        var cutAxis = new CutAxis();
        cutAxis.setCutData.apply(cutAxis, cutAxisData);
        view.setCutAxis(cutAxis);
      }
    };
    obj.cleanup = function () {
      obj.deleteModel(function () {
        view.cleanup();
      });
    };
    return obj;
  };

  var AnnotationCtrlReadOnly = function (annotationUI, viewerUI) {
    var annotation = annotationUI.getAnnotation();
    var obj = MVCCtrl(annotation);
    annotationUI.getAnnotationContainer().click(function (event) {
      event.preventDefault();
      event.stopPropagation();
      var views = annotationUI.getViewsElem();
      if (views.length > 0) {
        obj.rootCtrl.setViewActive(views[0]);
        views[0].show(viewerUI.viewer);
      } else {
        obj.rootCtrl.setViewActive(null);
      }
      obj.rootCtrl.setAnnotationActive(annotationUI);
    });
    return obj;
  };

  var AnnotationCtrl = function (annotationUI, viewerUI) {
    var annotation = annotationUI.getAnnotation();
    var obj = AnnotationCtrlReadOnly(annotationUI, viewerUI);
    var textElem = annotationUI.getTextElem();
    var saveElem = annotationUI.getSaveElem();

    var createAnnotation = function (callback) {
      obj.rootCtrl.newAnnotation = null;
      annotation.vCtrl.updateViewerData();
      obj.postModel(function (response) {
        var vUi = annotation.getViews()[0].viewObj;
        obj.rootCtrl.setAnnotationActive(annotationUI);
        obj.rootCtrl.setViewActive(vUi);
        Annotation.parse(response, [], []);
        //uiView.addAnnotBtn.hide();

        obj.rootCtrl.uiView.setStateBtn.show();
        obj.rootCtrl.uiView.setSolvedBtn.show();
        $.Topic(annotation.channel).unsubscribe(annotation.reset);
        if (callback) {
          callback();
        }
      });
    };

    textElem.bind("click", function (event) {
      if (obj.rootCtrl.isAnnotationActive(annotationUI))
        event.stopPropagation();
    });
    textElem.bind("input change", function () {
      annotation.setText(textElem.val());
      obj.rootCtrl.apiCtrl.queueUpdate(annotation);
    });
    saveElem.bind("click", function (event) {
      if (obj.rootCtrl.isAnnotationActive(annotationUI)) {
        createAnnotation();
        event.stopPropagation();
      }
    });
    annotationUI.getDeleteElem().click(function (event) {
      event.stopPropagation();
      if (!annotation.getId()) {
        obj.rootCtrl.setAnnotationActive(null);
        annotation.cleanup();
        return;
      }
      obj.deleteModel(function (data) {
        var annotation_resp = data[annotation.getId()];
        if (annotation_resp == true) {
          obj.rootCtrl.setAnnotationActive(null);
          annotation.cleanup();
        } else if (annotation_resp) {
          annotation.setDtime(annotation_resp);
          var views = annotation.getViews();
          for (var i = 0; i < views.length; i++) {
            views[i].cleanup();
          }
          annotation.removeViews();
          obj.rootCtrl.setViewActive(null);
        }
      });
    });
    obj.pushView = function (viewUI) {
      annotation.addView(viewUI.getModel());
      annotationUI.pushViewUI(viewUI);
    };

    //var annotationRoot = annotationUI.getAnnotationRoot();
    //var dragCallback = function(dx, dy, event){
    //var offset = annotationRoot.offset();
    //annotationRoot.offset({top: offset.top + dy, left: offset.left + dx});
    //}
    //var stopDragCallback = function(evt){
    //var minDist = 100000;
    //var minAnchor = null;
    //for(var i = 0; i < anchors.length; i++){
    //var anchor = anchors[i];
    //var dist = anchor.distance(annotationRoot.offset());
    //if(dist < minDist){
    //minDist = dist;
    //minAnchor = anchor;
    //}
    //}
    //if(minAnchor.annotation.channel == annotation.channel){
    //annotationRoot.offset(annotationUI.getInitialOffset());
    //annotationUI.removeFromResponse();
    //}else
    //minAnchor.setRespondTo(annotation);
    //annotationRoot.attr('style', '');
    //}
    //var stopDrag = setDraggable(annotationUI.getDraggable(), dragCallback, true, annotationRoot, stopDragCallback);
    return obj;
  };

  var UIView = function (viewerUI) {
    var obj = {};
    var UIRoot = function (root) {
      var uiRoot = $("<div>");
      uiRoot.addClass("left-over-viewer");
      root.append(uiRoot);
      return uiRoot;
    };
    var AddAnnotRoot = function (root) {
      var addAnnotRoot = $("<div>");
      addAnnotRoot.addClass("right-over-viewer");
      root.append(addAnnotRoot);
      return addAnnotRoot;
    };
    var root = $("#annotation-editor-widget");
    var uiRoot = UIRoot(root);
    var title = $("<label>");
    title.text("Annotations");
    uiRoot.append(title);
    var annotRoot = new AddAnnotRoot(root);
    obj.detach = function () {
      uiRoot.detach();
      root.children().detach();
    };
    var viewer = viewerUI.viewer;
    var viewerOffset = viewer.$jself.offset();
    var viewerWidth = viewer.getWidth();
    var viewerHeight = viewer.getHeight();
    var ySpacing = 20;
    var xSpacing = 20;
    var bottomRight = {
      x: viewerOffset.left + viewerWidth,
      y: viewerOffset.top + viewerHeight - xSpacing,
    };
    var appendToActions = function (actiontext, actionclass, cta) {
      var btn = $("<button>");
      var iconContainer = $("<div>");

      iconContainer.addClass(actionclass);
      btn.addClass("add-widget");
      if (cta) {
        btn.addClass("blue-button");
      } else {
        btn.addClass("gray-button");
      }
      btn.text(actiontext);
      btn.prepend(iconContainer);
      annotRoot.append(btn);
      return btn;
    };

    //obj.addTextBtn = appendToActions(gettext("Add text"), "annot-text");
    obj.addCircleBtn = appendToActions(gettext("Add circle"), "annot-circle");
    obj.addMarkBtn = appendToActions(gettext("Add mark"), "annot-mark");
    obj.addImgBtn = appendToActions(gettext("Add image"), "annot-img");

    //obj.addAnnotBtn = appendToActions(gettext("Add annotation"), "", true);
    obj.setStateBtn = $("<button>");
    obj.setStateBtn.addClass("blue-button");
    obj.setStateBtn.addClass("pending-button");
    obj.setStateBtn.text(gettext("Publish annotations"));
    obj.setStateBtn.hide();
    obj.setSolvedBtn = $("<button>");
    obj.setSolvedBtn.addClass("blue-button");
    obj.setSolvedBtn.addClass("pending-button");
    obj.setSolvedBtn.text(gettext("Close annotations"));
    if (canSetPending) {
      annotRoot.append(obj.setStateBtn);
      annotRoot.append(obj.setSolvedBtn);
    }
    obj.setSolvedBtn.hide();
    //if(canSetPending){
    //}else{
    //obj.setStateBtn.text("Request Support");
    //}

    obj.append = function (elem) {
      uiRoot.append(elem);
    };
    obj.createDownloadUI = function () {
      var form = $('<form enctype="multipart/form-data">');
      var uploadInp = $(
        '<input name="file" type="file" multiple accept="image/*" >'
      );
      form.append(uploadInp);
      var uploadContainer = $("<div>");
      uploadContainer.append(form);
      uploadContainer.addClass("upload-pos");
      var detach = function () {
        uploadContainer.detach();
      };
      var exitForm = $("<div>");
      exitForm.addClass("delete-elem-btn");
      exitForm.text("×");
      uploadContainer.append(exitForm);
      root.append(uploadContainer);
      var offset = uploadContainer.offset();
      uploadContainer.offset({
        top: offset.top - uploadContainer.height() / 2,
        left: offset.left - uploadContainer.width() / 2,
      });
      return {
        uploadInp: uploadInp,
        detach: detach,
        root: uploadContainer,
        form: form,
        exitForm: exitForm,
      };
    };
    obj.createConfirmUI = function () {
      var confirmWindow = $("<div>");
      var text = $("<div>");
      text.text(
        gettext(
          "You have annotations that have not been saved. You can save them, discard them or close this dialog and go back to them"
        )
      );
      var delBtn = $("<button>");
      delBtn.addClass("annotation-delete");
      delBtn.text("×");
      var save = $("<button>");
      save.text(gettext("Save all annotations now"));
      save.addClass("blue-button");
      var discard = $("<button>");
      discard.text(gettext("Discard unsaved annotations"));
      discard.addClass("blue-button");
      confirmWindow.append(delBtn);
      confirmWindow.append(text);
      confirmWindow.append(discard);
      confirmWindow.append(save);
      text.addClass("window-pop-up");
      confirmWindow.addClass("upload-pos");
      root.append(confirmWindow);
      var offset = confirmWindow.offset();
      confirmWindow.offset({
        top: offset.top - confirmWindow.height() / 2,
        left: offset.left - confirmWindow.width() / 2,
      });
      return {
        confirmWindow: confirmWindow,
        close: delBtn,
        save: save,
        discard: discard,
      };
    };
    return obj;
  };

  var ConfirmUI = function (rootUI) {};

  var UICtrl = function (uiView, global_viewerUI, design_uuid) {
    var obj = {};
    modelCreatedChannel = Utils.uniqueString();
    obj.design_uuid = design_uuid;
    obj.uiView = uiView;
    var activeAnnotations = {};
    var singleSelection = true;
    var setAnnotationActive = function (annotationUI) {
      if (annotationUI) annotationUI.removeReview();
      // Reset Active Annotations
      if (annotationUI && annotationUI.key in activeAnnotations) {
        if (singleSelection) {
          if (Object.keys(activeAnnotations).length <= 1) {
            var activeAnnotation = activeAnnotations[annotationUI.key];
            activeAnnotation
              .getSelectionContainer()
              .removeClass("active-annotation");
            $(".save-annotation").hide();
            delete activeAnnotations[annotationUI.key];
            setViewActive(null);
            return;
          }
        } else {
          var activeAnnotation = activeAnnotations[annotationUI.key];
          activeAnnotation
            .getSelectionContainer()
            .removeClass("active-annotation");
          $(".save-annotation").hide();
          delete activeAnnotations[annotationUI.key];
          return;
        }
      }
      if (singleSelection) {
        for (var key in activeAnnotations) {
          var activeAnnotation = activeAnnotations[key];
          activeAnnotation
            .getSelectionContainer()
            .removeClass("active-annotation");
          $(".save-annotation").hide();
        }
        activeAnnotations = {};
      }
      if (annotationUI) {
        if (!canSetPending) global_viewerUI.viewer.setLocal(true);
        global_viewerUI.viewer.setAutorotate(false);
        //setViewActive(null);
        activeAnnotations[annotationUI.key] = annotationUI;
        annotationUI.getSelectionContainer().addClass("active-annotation");
        $(".save-annotation").show();
      }
      $(activeAnnotations.getAnnotationContainer).append("<button/>");
    };
    var getActiveAnnotation = function () {
      var annotations = Object.keys(activeAnnotations);
      if (annotations.length == 1) {
        return activeAnnotations[annotations[0]];
      } else {
        return null;
      }
    };
    obj.isAnnotationActive = function (annotationUI) {
      return activeAnnotations[annotationUI.key];
    };
    $(window).keydown(function (evt) {
      if (evt.keyCode == 17) singleSelection = false;
    });
    $(window).keyup(function (evt) {
      if (evt.keyCode == 17) singleSelection = true;
    });
    var activeView = null;
    var setViewActive = function (viewUI) {
      if (activeView == viewUI) return;
      if (activeView) {
        activeView.detach();
        activeView.is_active = false;
      }
      activeView = viewUI;
      if (activeView) activeView.is_active = true;
    };
    var reset_on_move = function () {
      // Marker is the last argument
      var _marker = arguments[arguments.length - 1];
      var activeAnnotation = getActiveAnnotation();
      if (!activeAnnotation) return;
      if (
        activeAnnotation.getModel().getState() != gettext("editing") &&
        _marker != marker &&
        !getAnimating()
      ) {
        console.trace(arguments);
        setAnnotationActive(null);
        setViewActive(null);
      }
    };
    global_viewerUI.viewer.bind("camera", reset_on_move);
    global_viewerUI.viewer.bind("pan", reset_on_move);
    global_viewerUI.viewer.bind("zoom", reset_on_move);
    obj.setAnnotationActive = setAnnotationActive;
    obj.setViewActive = setViewActive;
    var pendingViewTexts = [];
    obj.newAnnotation = null;
    //uiView.addAnnotBtn.hide();
    uiView.setStateBtn.show();
    uiView.setSolvedBtn.show();
    var _getNewAnnotation = function (activeAnnotation) {
      if (obj.newAnnotation) {
        return obj.newAnnotation;
      } else {
        var annotation = new Annotation();
        var resetAnnotationOnDelete = function (data) {
          if (data.deleted) {
            //uiView.addAnnotBtn.hide();
            uiView.setStateBtn.show();
            uiView.setSolvedBtn.show();
            obj.newAnnotation = null;
          }
        };
        $.Topic(annotation.channel).subscribe(resetAnnotationOnDelete);
        var ui = new AnnotationUI(annotation, viewerUI, uiView);
        ui.subscribe(function (data) {
          if (data.deleted) obj.newAnnotation = null;
        });
        var ctrl = new AnnotationCtrl(ui, viewerUI);
        ctrl.setRootCtrl(obj);
        var view = new View();
        var vUi = new ViewUI(view);
        if (activeAnnotation) var roAnnot = activeAnnotation.getModel();
        if (roAnnot && roAnnot.isOtherAuthor())
          annotation.setRespondTo(roAnnot.getId());
        var vCtrl = new ViewCtrl(vUi, viewerUI);
        vCtrl.setRootCtrl(obj);
        ctrl.pushView(vUi);
        //Publish Monkey style
        annotation.vCtrl = vCtrl;
        annotation.reset = resetAnnotationOnDelete;
        obj.newAnnotation = {
          el: annotation,
          ui: ui,
          ctrl: ctrl,
          vUi: vUi,
          vCtrl: vCtrl,
          vEl: view,
          reset: resetAnnotationOnDelete,
        };
        //uiView.addAnnotBtn.show();
        uiView.setStateBtn.hide();
        uiView.setSolvedBtn.hide();
        return obj.newAnnotation;
      }
    };
    var getNewAnnotation = function () {
      var activeAnnotation = getActiveAnnotation();
      var promise = $.Deferred();
      if (activeAnnotation && !activeAnnotation.getModel().readOnly()) {
        var annotation = activeAnnotation.getModel();
        var views = activeAnnotation.getViewsElem();
        if (views.length < 1) return null;
        var viewUI = views[0];
        var view = viewUI.getModel();
        if (annotation.getId()) {
          promise.done(function (elem, ctrl, ui) {
            ctrl.postModel(function (data) {
              ui.attach();
              elem.setId(data["id"]);
            });
          });
        } else {
          promise.done(function (elem, ctrl, ui) {
            //ui.attach();
          });
        }
        return {
          el: annotation,
          ui: activeAnnotation,
          vUi: viewUI,
          vEl: view,
          promise: promise,
        };
      } else {
        var annotationData = _getNewAnnotation(activeAnnotation);
        setAnnotationActive(annotationData.ui);
        setViewActive(annotationData.vUi);
        annotationData.vUi.show(global_viewerUI.viewer);
        promise.done(function (elem, ctrl, ui) {
          //ui.attach();
        });
        annotationData.promise = promise;
        return annotationData;
      }
    };
    var imgBuilding = true;
    var _createViewerImage = function (viewerUI, imgSrc, uploadUI) {
      var annotationData = getNewAnnotation();
      if (annotationData == null) return;
      var view = annotationData.vEl;
      var viewerImage = new ViewerImage();
      viewerImage.setImageSrc(imgSrc);
      viewerImage.setPos(0.3, 0);
      var ui = new ViewerImageUI(viewerImage, viewerUI, uiView);
      var ctrl = new ViewerImageCtrl(ui);
      ctrl.setRootCtrl(obj);
      view.addViewerElem(viewerImage);
      annotationData.promise.resolve(viewerImage, ctrl, ui);
      uploadUI.detach();
      imgBuilding = true;
    };
    var handleFileId = function (viewerUI, uploadUI) {
      return function (data) {
        var key = JSON.parse(data)["key"];
        var req = $.get(URLS["x_new_media"], { key: key, type: "image" });
        req.success(function (fileData) {
          _createViewerImage(viewerUI, fileData["url"], uploadUI);
        });
      };
    };
    var createViewerImage = function (viewerUI) {
      var uploadUI = uiView.createDownloadUI();
      uploadUI.uploadInp.bind("change", function () {
        var fd = new FormData(uploadUI.form[0]);
        var req = $.ajax({
          type: "POST",
          url: URLS["upload_file"],
          data: fd,
          processData: false,
          contentType: false,
          beforeSend: function (xhr) {
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
          },
        });
        req.success(handleFileId(viewerUI, uploadUI));
      });
      uploadUI.exitForm.bind("click", function () {
        uploadUI.detach();
        imgBuilding = true;
      });
    };
    uiView.addImgBtn.click(function () {
      if (imgBuilding) {
        imgBuilding = false;
        createViewerImage(global_viewerUI);
      }
    });
    //Remove Text option
    /*var createViewText = function(viewerUI){
			var annotationData = getNewAnnotation();
			if(annotationData == null) return;
			var view = annotationData.vEl;
			var viewText = new ViewerText();
			viewText.setPos(0.3, 0);
			var ui = new ViewerTextUI(viewText, viewerUI, uiView);
			var ctrl = new ViewerTextCtrl(ui);
			ctrl.setRootCtrl(obj);
			view.addViewerElem(viewText);
			annotationData.promise.resolve(viewText, ctrl, ui);
		}
		uiView.addTextBtn.click(function(){
			createViewText(global_viewerUI);
		});*/
    var createViewerCircle = function (viewerUI) {
      var annotationData = getNewAnnotation();
      if (annotationData == null) return;
      var view = annotationData.vEl;
      var viewerCircle = new ViewerCircle();
      viewerCircle.setPos(0.3, 0, 0.1);
      var ui = new ViewerCircleUI(viewerCircle, viewerUI, uiView);
      var ctrl = new ViewerCircleCtrl(ui);
      ctrl.setRootCtrl(obj);
      view.addViewerElem(viewerCircle);
      annotationData.promise.resolve(viewerCircle, ctrl, ui);
    };
    uiView.addCircleBtn.click(function () {
      createViewerCircle(global_viewerUI);
    });
    var createViewerMark = function (viewerUI) {
      var annotationData = getNewAnnotation();
      if (annotationData == null) return;
      var view = annotationData.vEl;
      var viewer = viewerUI.viewer;
      var promise = $.Deferred();
      _newConeNode(viewerUI, function (node) {
        viewer.setCursorNode(node);
        var modelNode = viewer.getNodesByName("model")[0];
        var onClickMark = function (x, y) {
          var transform = viewer.getCursorTransform(x, y);
          var el = new ViewerMark();
          el.setTransform(transform);
          var ui = new ViewerMarkUI(el, viewerUI, uiView);
          var ctrl = new ViewerMarkCtrl(ui);
          ctrl.setRootCtrl(obj);
          var data = { el: el, ui: ui, ctrl: ctrl };
          view.addViewerElem(el);
          promise.data = data;
          viewer.setCursorNode(null);
          promise.resolve();
          modelNode.removeEventListener("click", onClickMark);
          annotationData.promise.resolve(el, ctrl, ui);
        };
        modelNode.addEventListener("click", onClickMark);
      });
    };
    uiView.addMarkBtn.click(function () {
      createViewerMark(global_viewerUI);
    });
    var pendingViews = [];
    var createView = function (viewerUI) {
      var view = new View();
      view.setName("vue");
      var ui = new ViewUI(view);
      var ctrl = new ViewCtrl(ui, viewerUI, uiView);
      ctrl.setRootCtrl(obj);
      for (var i = 0; i < pendingViewTexts.length; i++) {
        ctrl.pushViewerElem(pendingViewTexts[i].ui);
      }
      pendingViewTexts = [];
      var data = { el: view, ui: ui, ctrl: ctrl };
      pendingViews.push(data);
      ctrl.show();
      return data;
    };
    /*		var createAnnotation = function(viewerUI, callback){
			var ann = _getNewAnnotation();
			newAnnotation = null;
			ann.vCtrl.updateViewerData();
			ann.ctrl.postModel(function(response){
				setAnnotationActive(ann.ui);
				setViewActive(ann.vUi);
				Annotation.parse(response, [], []);
				//uiView.addAnnotBtn.hide();
				uiView.setStateBtn.show();
				uiView.setSolvedBtn.show();
				$.Topic(ann.el.channel).unsubscribe(ann.reset);
				if(callback) callback();
			});
		}

		uiView.addAnnotBtn.click(function(){
			createAnnotation(global_viewerUI);
		});*/
    var apiCtrl = APICtrl(design_uuid);
    var modelCreationCtrl = function (model, instance) {
      if (model.ui && model.ctrl) {
        var ui = model.ui(instance, global_viewerUI, uiView);
        if (instance.readOnly() && model.ctrlRo) {
          var ctrl = model.ctrlRo(ui, global_viewerUI);
          ctrl.setRootCtrl(obj);
        } else if (!instance.readOnly()) {
          var ctrl = model.ctrl(ui, global_viewerUI);
          ctrl.setRootCtrl(obj);
        }
        instance.viewObj = ui;
      }
    };
    $.Topic(modelCreatedChannel).subscribe(modelCreationCtrl);
    var getModel = function () {
      apiCtrl.getModel(function (annotation_list) {
        var elements = [];
        var respondToList = {};
        for (var i = 0; i < annotation_list.length; i++) {
          var annotation = Annotation.parse(
            annotation_list[i],
            elements,
            respondToList
          );
        }
        for (var k in respondToList) {
          modelElements[k].setRespondTo(respondToList[k]);
        }
      });
    };
    getModel();
    var setState = function (newState) {
      var annotation_ids = [];
      var map = {};
      //for(var key in modelElements){
      //var annotation = modelElements[key];
      //if(annotation.getType() == Annotation){
      //annotation_ids.push(annotation.getId());
      //map[annotation.getId()] = annotation;
      //}
      //}
      for (var key in activeAnnotations) {
        var annotation = activeAnnotations[key].getModel();
        annotation_ids.push(annotation.getId());
        map[annotation.getId()] = annotation;
      }
      apiCtrl.postNewState(annotation_ids, newState, function (data) {
        for (var i = 0; i < data.length; i++) {
          map[data[i]].setState(newState);
        }
      });
      console.log(annotation);
    };
    var setDraft = function () {
      setState(0);
    };
    var setPending = function () {
      setState(2);
    };
    //if(canSetPending)
    uiView.setStateBtn.click(setPending);
    //else
    //uiView.setStateBtn.click(function(){
    //console.log("request help");
    //});
    var setClosed = function () {
      setState(4);
    };
    uiView.setSolvedBtn.click(setClosed);
    obj.apiCtrl = apiCtrl;
    obj.cleanup = function () {
      for (var key in modelElements) {
        var elem = modelElements[key];
        elem.cleanup();
      }
      $.Topic(modelCreatedChannel).unsubscribe(modelCreationCtrl);
      idMap = {};
      global_viewerUI.viewer.unbind("camera", reset_on_move);
      global_viewerUI.viewer.unbind("pan", reset_on_move);
      global_viewerUI.viewer.unbind("zoom", reset_on_move);
    };
    var createConfirmCtrl = function (confirmUI, callback) {
      confirmUI.close.click(function () {
        confirmUI.confirmWindow.detach();
      });
      confirmUI.save.click(function () {
        createAnnotation(global_viewerUI, function () {
          uiView.detach();
          obj.cleanup();
          global_viewerUI.viewer.setLocal(false);
          callback();
        });
      });
      confirmUI.discard.click(function () {
        uiView.detach();
        obj.cleanup();
        global_viewerUI.viewer.setLocal(false);
        callback();
      });
    };
    obj.quit = function (callback) {
      if (obj.newAnnotation) {
        var ui = uiView.createConfirmUI();
        createConfirmCtrl(ui, callback);
      } else {
        uiView.detach();
        for (var key in modelElements) {
          var elem = modelElements[key];
          elem.cleanup();
        }
        $.Topic(modelCreatedChannel).unsubscribe(modelCreationCtrl);
        global_viewerUI.viewer.setLocal(false);
        modelElements = {};
        idMap = {};
        callback();
      }
    };
    var listener = sculpteoNotification("annotation_" + design_uuid);
    listener.recv(function (msg) {
      if (msg.timestamp > lastTimeStamp) {
        lastTimeStamp = msg.timestamp;
        if (msg.deleted) {
          for (var key in msg.deleted) {
            console.log(key);
            var elem = modelElements[idMap[key]];
            if (msg.deleted[key] == true) elem.cleanup();
          }
        }
        getModel();
        console.log([msg.timestamp, lastTimeStamp]);
        console.log(msg);
      }
    });
    listener.startListening();
    return obj;
  };

  var setUp = function () {
    var global_viewer = window.viewerUI.viewer;
    var global_viewerUI = window.viewerUI;
    if (!canSetPending) global_viewer.setLocal(true);
    global_viewer.setAutorotate(false);
    var design_uuid = window.viewerUI.design.design_uuid;
    var uiView = UIView(global_viewerUI);
    var uiCtrl = UICtrl(uiView, global_viewerUI, design_uuid);
    return uiCtrl.quit;
  };

  return {
    setUp: setUp,
    setTypes: setTypes,
    setMarkAsRead: setMarkAsRead,
    enablePending: enablePending,
  };
})(AnnotationModule || {});

function ViewerUIMock(viewer, script_op_id, design) {
  this.init_cone_node = function (size, name, invert) {
    return init_cone_node(viewer, script_op_id, size, name, invert);
  };
  this.get_cursor_material = get_cursor_material;
  this.viewer = viewer;
  this.design = design;
}
